import type { CalendarProps } from './calendar-types'
import CalendarHeader from './header/calendar-header'
import CalendarBody from './body/calendar-body'
import CalendarHeaderActions from './header/actions/calendar-header-actions'
import CalendarHeaderDate from './header/date/calendar-header-date'
import CalendarHeaderActionsMode from './header/actions/calendar-header-actions-mode'
import CalendarHeaderActionsAdd from './header/actions/calendar-header-actions-add'
import CalendarProvider from './calendar-provider'
import { useEffect } from 'react'

export default function Calendar({
  events,
  setEvents,
  mode,
  setMode,
  date,
  setDate,
  vehicles,
  setVehicles,
  locations,
  setLocations,
  partners,
  setPartners,
  reservationStates,
  setReservationStates,
  calendarIconIsToday = true,
}: CalendarProps) {

  return (
    <CalendarProvider
      events={events}
      setEvents={setEvents}
      mode={mode}
      setMode={setMode}
      date={date}
      setDate={setDate}
      vehicles={vehicles || []}
      setVehicles={setVehicles || ""}
      locations={locations || []}
      setLocations={setLocations || ""}
      partners={partners || []}
      setPartners={setPartners || ""}
      reservationStates={reservationStates || []}
      setReservationStates={setReservationStates || ""}
      calendarIconIsToday={calendarIconIsToday}
    >
      <CalendarHeader>
        <CalendarHeaderDate />
        <CalendarHeaderActions>
          <CalendarHeaderActionsMode />
          <CalendarHeaderActionsAdd />
        </CalendarHeaderActions>
      </CalendarHeader>
      <CalendarBody />
    </CalendarProvider>
  )
}
